import React, { useEffect, useState } from "react";
import { withRouter } from "react-router-dom";
import ValidationErrorToast from "../../components/validationErrorToast";
import { mploiAI } from "../../store/reducers/mploiAI";
import { STRING_CONSTANTS } from "../../utils/constants/stringConstants";
import { UtilityFunctions } from "../../utils/UtilityFunctions";
import { cookieService, userService } from "../../_services";
import { isEmpty } from 'lodash';
import Logout from "../../components/logout";
import { Data } from "../../_services/collections";
import { blobToFile, dataURLtoFile } from "../../utils/UtilityFunctions";

async function getFileFromUrl(url, filename) {
    const response = await fetch(url);
    const blob = await response.blob();
    return blobToFile(blob, filename);
}

const BusinessURL = (props: any) => {
    const [url, setUrl] = useState("");
    const [btnClick, setBtnClick] = useState(false);
    const [show, setShow] = useState(false);

    const urlInputHandler = event => {
        const result = event.target.value;
        setUrl(result);
    };

    useEffect(() => {
        let user = cookieService.getCookie(STRING_CONSTANTS.cookieStrings.user);
        //setUrl((user as Data)?.url);
    }, [])

    const urlSubmitHandler = async (e) => {
        e.preventDefault();
        if (url?.length) {
            let result;
            try {
                result = await mploiAI({ method: 'get-business-info', data: {url: url.trim()}});
            } catch (e) {
                console.error(e);
                //props?.nav?.next();
            }
            if (!result) result = {};
            if (result) {
                let formData = new FormData();
                if (result.businessName && result.businessName.length && result.businesName !== 'null') {
                    formData.append('businessName', result.businessName);
                    formData.append('tradingName', result.businessName);
                }
                if (result.estEmployees) {
                    const estEmployees = parseInt(result.estEmployees, 10);
                    if (isNaN(estEmployees)) {
                        //formData.append('totalEmployees', 0);
                    } else {
                        formData.append('totalEmployees', estEmployees);
                    }
                }
                if (result.logo) {
                    const binaryData = await getFileFromUrl(result.logo);
                    formData.append('logo', binaryData);
                }
                userService
                    .userProfile(formData)
                    .then(() => {
                        props?.nav?.next();
                    })
                    .catch((e) => {
                        props?.nav?.next();
                        console.error(e[0], e[1])
                    })
           }
        }
    }

    return <>
        <div className='top-divde-spa'>
            <span>
                <i
                    className="text-white d-flex justify-content-between"
                    aria-hidden="true"
                    onClick={() => setShow(true)}
                >
                    <img src={UtilityFunctions.getImageURL() + "cross-icon-white.svg"} width={'22px'} height={'22px'} alt="" />
                    {/* <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                        <path d="M4.2097 4.3871L4.29289 4.29289C4.65338 3.93241 5.22061 3.90468 5.6129 4.2097L5.70711 4.29289L12 10.585L18.2929 4.29289C18.6834 3.90237 19.3166 3.90237 19.7071 4.29289C20.0976 4.68342 20.0976 5.31658 19.7071 5.70711L13.415 12L19.7071 18.2929C20.0676 18.6534 20.0953 19.2206 19.7903 19.6129L19.7071 19.7071C19.3466 20.0676 18.7794 20.0953 18.3871 19.7903L18.2929 19.7071L12 13.415L5.70711 19.7071C5.31658 20.0976 4.68342 20.0976 4.29289 19.7071C3.90237 19.3166 3.90237 18.6834 4.29289 18.2929L10.585 12L4.29289 5.70711C3.93241 5.34662 3.90468 4.77939 4.2097 4.3871L4.29289 4.29289L4.2097 4.3871Z" fill="white" />
                    </svg> */}
                </i>
            </span>
            <Logout
                show={show}
                handleClose={() => setShow(false)}
            />
            <div className="step-content signup-mar">
                <button type='button' disabled>
                    {STRING_CONSTANTS.employerProfileCompletionPages.url_validation.trading_details}
                </button>
                <p>{STRING_CONSTANTS.employerProfileCompletionPages.url_validation.enter_url}</p>
                <div className="step-text">
                    {STRING_CONSTANTS.employerProfileCompletionPages.url_validation.step}
                </div>
            </div>
        </div>
        <form onSubmit={urlSubmitHandler}>
            <div className="form-wrap">
                <div className='v-form-width'>
                    <div className="form-floating mb-3">
                        <input type='text' className={`form-control ${btnClick && isEmpty(url) ? 'error' : ""}`} placeholder='Enter Business URL' value={url} onChange={(e) => { urlInputHandler(e); setBtnClick(false); }}></input>
                        <label htmlFor="floatingInput">Business website</label>
                        <span className="input-group-text">
                            <img src={UtilityFunctions.getImageURL() + "hashtag.svg"} alt="" />
                            <img src={UtilityFunctions.getImageURL() + "hashtag-fill.svg"} alt="" />
                        </span>
                    </div>
                </div>
            </div>
        </form>
        <div className="next-wrap">
            <button className={
                // abn?.length === 11 ? 
                "cricle-next"
                // : "cricle-next-inactive"
            }
                onClick={(e) => urlSubmitHandler(e)}>
                <img
                    alt=""
                    src={UtilityFunctions.getImageURL() + "arrow-bottom.svg"}
                />
            </button>
        </div>
    </>
}

export default withRouter(BusinessURL);
